/* eslint-disable*/
import { SwipeableDrawer, useTheme } from '@mui/material'
import { Outlet } from 'react-router-dom'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import logo from '../assets/85A6933F.png'
import { useState } from 'react'
import { AuthCarouselDesktop, AuthCarouselMobile } from '../Components/Auth/AuthCarousel'
// CleverTap removed - using PostHog
import env from '../env/env'

const LoginContainer = () => {
  // const navigate = useNavigate()
  const theme = useTheme()
  const [open, setOpen] = useState(false)

  return (
    <>
      <div className='relative isolate h-[100svh] min-h-[100svh] w-full max-w-full overflow-hidden bg-[#040313] lg:hidden'>
        <div className='absolute inset-x-0 top-0 z-30 flex h-20 items-center justify-center bg-gradient-to-b from-[#040313] via-[#040313]/80 to-transparent'>
          <img src={logo} alt='fabits' className='h-6' />
        </div>
        <AuthCarouselMobile />

        <button
          type='button'
          className={`${
            open ? 'pointer-events-none translate-y-4 opacity-0' : 'translate-y-0 opacity-100'
          } absolute inset-x-0 bottom-0 z-20 mx-auto flex min-h-[128px] w-full max-w-[430px] flex-col items-center justify-center rounded-t-[36px] bg-white px-6 pb-[calc(24px+env(safe-area-inset-bottom))] pt-6 text-center shadow-[0_-24px_70px_rgba(4,3,19,0.22)] transition-all duration-200`}
          onClick={() => {
            setOpen(!open)
          }}
        >
          <span className='mb-4 h-1 w-11 rounded-full bg-black-200' />
          <h2 className='font-IBM text-[30px] font-bold leading-9 text-black-950'>Get started</h2>

          <p className='mt-2 max-w-[260px] font-IBM text-sm font-medium leading-5 text-black-400'>
            Tap to begin your journey
          </p>
        </button>

        {/* <Drawer open={open} onOpenChange={setOpen} className='fixed bottom-0'>
          <DrawerContent
            side='bottom'
            className={`flex flex-col justify-end !h-min min-h-[50vh] max-h-[85vh] items-center bottom-0
              pb-0 outline-none`}
          >
            <div className='pb-6 w-full px-6 h-full overflow-auto mt-8' data-vaul-no-drag>
              <Outlet />
              <div className='mt-6'>
                <p className='text-black-300 text-[10px] text-center'>
                  Shareway Securities Limited (SEBI Reg. no. INZ000208134) NSE Member Code 13093 |
                  CDSL - SEBI Reg. No. IN-DP-610-2021 Registered with NSE India Limited with
                  approved segments Capital Market and F&O
                </p>
                <div className='text-[10px] flex gap-x-2 justify-center text-primary-500 mt-1'>
                  <a
                    href='https://start.fabits.com/termsandconditions'
                    target='_blank'
                    rel='noreferrer'
                    style={{
                      textDecoration: 'none',
                      display: 'inline-block',
                      borderBottom: `2px dashed ${theme.palette.primary.main}`,
                    }}
                    className='font-semibold'
                  >
                    Terms & Conditions
                  </a>
                  <a
                    href='https://start.fabits.com/privacypolicy'
                    target='_blank'
                    rel='noreferrer'
                    style={{
                      textDecoration: 'none',
                      display: 'inline-block',
                      borderBottom: `2px dashed ${theme.palette.primary.main}`,
                    }}
                    className='font-semibold'
                  >
                    Privacy Policy
                  </a>
                </div>
              </div>
            </div>
          </DrawerContent>
        </Drawer> */}
        <SwipeableDrawer
          anchor='bottom'
          open={open}
          onOpen={setOpen}
          onClose={() => setOpen(false)}
          disableSwipeToOpen
          sx={{
            '& .PrivateSwipeArea-root': {
              maxWidth: '100%',
              overflow: 'hidden',
              width: '100% !important',
            },
            '& .MuiBackdrop-root': {
              backdropFilter: 'blur(10px)',
              backgroundColor: 'rgba(4, 3, 19, 0.42)',
            },
            '& .MuiPaper-root': {
              borderTopLeftRadius: '32px',
              borderTopRightRadius: '32px',
              boxShadow: '0 -24px 80px rgba(4, 3, 19, 0.24)',
              boxSizing: 'border-box',
              marginInline: 'auto',
              maxWidth: '430px',
              overflowX: 'hidden',
              width: '100%',
            },
          }}
        >
          <div className='relative mx-auto h-full w-full max-w-[390px] overflow-y-auto overflow-x-hidden px-6 pb-6 pt-8'>
            <div className='absolute left-1/2 top-4 h-1 w-8 -translate-x-1/2 rounded-full bg-primary-200' />
            <Outlet />
            <div className='mt-6'>
              <p className='text-black-300 text-[10px] text-center'>
                Fabits Capital Services LLP | BSE Member ID 61731 | ARN - 344673 | REGISTERED WITH
                AMFI
              </p>
              <div className='text-[10px] flex gap-x-2 justify-center text-primary-500 mt-1'>
                <a
                  href='https://start.fabits.com/termsandconditions'
                  target='_blank'
                  rel='noreferrer'
                  style={{
                    textDecoration: 'none',
                    display: 'inline-block',
                    borderBottom: `2px dashed ${theme.palette.primary.main}`,
                  }}
                  className='font-semibold'
                >
                  Terms & Conditions
                </a>
                <a
                  href='https://start.fabits.com/privacypolicy'
                  target='_blank'
                  rel='noreferrer'
                  style={{
                    textDecoration: 'none',
                    display: 'inline-block',
                    borderBottom: `2px dashed ${theme.palette.primary.main}`,
                  }}
                  className='font-semibold'
                >
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
        </SwipeableDrawer>
      </div>

      <div className='hidden lg:flex justify-between items-stretch max-h-screen h-screen max-w-screen-2xl mx-auto'>
        <div className='flex-1 flex flex-col justify-center items-center w-1/2'>
          <AuthCarouselDesktop />
        </div>
        <div className='flex-1 w-1/2 p-12 flex flex-col justify-between relative'>
          <div className='flex justify-end my-3'>
            <img src={`${env.SVGS}/logo.svg`} alt='Fabits' className='h-8' />
          </div>
          <Outlet />

          <div className='mt-2'>
            <p className='text-black-300 text-[10px] text-right font-medium leading-3'>
              <span className='font-semibold'>Fabits Capital Services LLP</span> <br /> BSE Member
              ID 61731 | ARN - 344673 | REGISTERED WITH AMFI
            </p>
            <div className='text-[10px] flex gap-x-6 justify-end text-primary-500 mt-1'>
              <a
                href='https://start.fabits.com/termsandconditions'
                target='_blank'
                rel='noreferrer'
                style={{
                  textDecoration: 'none',
                  display: 'inline-block',
                  borderBottom: `2px dashed ${theme.palette.primary.main}`,
                }}
                className='font-semibold'
              >
                Terms & Conditions
              </a>
              <a
                href='https://start.fabits.com/privacypolicy'
                target='_blank'
                rel='noreferrer'
                style={{
                  textDecoration: 'none',
                  display: 'inline-block',
                  borderBottom: `2px dashed ${theme.palette.primary.main}`,
                }}
                className='font-semibold'
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LoginContainer
